import { useEffect, useRef } from 'react';
import { isIOS, isAndroid, isNative } from '../utils/platform';
import { deliverDeepLink } from '../services/deepLink';

export default function useNativeSetup() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    (async () => {
      try {
        if (isIOS() || isAndroid()) {
          const { StatusBar, Style } = await import('@capacitor/status-bar');
          await StatusBar.setStyle({ style: Style.Light });
          if (isAndroid()) await StatusBar.setBackgroundColor({ color: '#ffffff' });
        }

        if (isNative()) {
          const { SplashScreen } = await import('@capacitor/splash-screen');
          await SplashScreen.hide();
        }

        if (isAndroid()) {
          const { App } = await import('@capacitor/app');
          App.addListener('backButton', ({ canGoBack }) => {
            if (canGoBack) window.history.back();
            else App.exitApp();
          });
        }

        if (isNative()) {
          const { App } = await import('@capacitor/app');
          App.addListener('appUrlOpen', async ({ url }) => {
            if (url?.includes('/auth/callback')) {
              try {
                const { Browser } = await import('@capacitor/browser');
                await Browser.close();
              } catch { /* browser plugin may not be in use on iOS */ }
              return;
            }
            // Share-extension deep links (cooksmith://import?url=… | ?text=…).
            // deliverDeepLink buffers if the router hasn't mounted yet.
            deliverDeepLink(url);
          });

          // Cold start via deep link — appUrlOpen may not fire, so also check
          // the launch URL. deliverDeepLink dedupes if both report it.
          try {
            const launch = await App.getLaunchUrl();
            if (launch?.url) deliverDeepLink(launch.url);
          } catch { /* getLaunchUrl unsupported — appUrlOpen still covers warm opens */ }
        }
      } catch (err) {
        console.warn('Native setup error (non-fatal):', err);
      }
    })();
  }, []);
}
